<script lang="ts">
  import BackBtn from '$lib/components/common/BackBtn.svelte';
  import Loading from '$lib/components/Loading.svelte';
  import CategorySkillListGrid from '$lib/components/student/CategorySkillListGrid.svelte';
  import type { PageProps } from './$types';

  let { data, params }: PageProps = $props();
  let skillCategoryId = $derived(parseInt(params.skillCategoryId));
</script>

<BackBtn />

{#await data.classPromise}
  <Loading />
{:then leaderboard}
  <CategorySkillListGrid
    classId={leaderboard.classId}
    classEndDate={leaderboard.class.endDate}
    classStartDate={leaderboard.class.startDate}
    categories={leaderboard.class.course.skillCategories.filter(x => x.id === skillCategoryId)}
    skills={leaderboard.skills.filter(x => x.skillCategoryId === skillCategoryId)}
    badgeProgressItems={leaderboard.badgeProgress}
  />
{/await}
